module.exports = __webpack_public_path__ + "img/icon-warning-flood-red.1db8cc08.svg";